'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isMotionValue = require('../../../value/utils/is-motion-value.js');
const scrapeMotionValues = require('../../html/utils/scrape-motion-values.js');

function scrapeMotionValuesFromProps(props) {
  var newValues = scrapeMotionValues.scrapeMotionValuesFromProps(props);
  for (var key in props) {
    if (isMotionValue.isMotionValue(props[key])) {
      var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

exports.scrapeMotionValuesFromProps = scrapeMotionValuesFromProps;
